import React from 'react';
import axios from 'axios';
import { Button, Form, Table, Select, Loader, Popup, Grid, Label, Icon } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import EditCourse from './EditCourse';
import { Tab } from 'semantic-ui-react/dist/commonjs/modules/Tab';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema predmeta.</p>;
const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema predmeta.</p>;

class SemesterAddedCourses extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semesters: [],
            data: [],
            courseName: '',
            studyProgramSemesterId: '',
            course: {},
            showEditMode: false,
            showChangeSemesterMode: false,
            semErr: false,
            loading: true
        };
        this.getCoursesForSemester = this.getCoursesForSemester.bind(this);
        this.deleteCourse = this.deleteCourse.bind(this);
        this.changeSemester = this.changeSemester.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        let semesters = this.props.semesters.map(el => ({
            ...el, key: el.id, value: el.id, text: el.studyProgramSemester.name
        }));
        this.setState({ semesters });
        this.getCoursesForSemester();
    }

    componentDidUpdate(prevState) {
        if (localStorage.getItem('changeSemester')) {
            this.getCoursesForSemester();
        }
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    getCoursesForSemester() {
        let id = JSON.parse(localStorage.getItem('implementation')).id ? JSON.parse(localStorage.getItem('implementation')).id : JSON.parse(localStorage.getItem('implementation')).studyProgram.id
        axios.get(`study-programs/semesters/courses/${id}/${this.props.semesterNumber}`)
            .then(res => {
                this.setState({ data: res.data.sort((a, b) => b.mandatory - a.mandatory).sort((b, a )=> b.fromOtherStudyProgram - a.fromOtherStudyProgram), loading: false });
                localStorage.removeItem('changeSemester');
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    deleteCourse(id) {
        let obj = { id };
        axios.delete('study-programs/semesters/remove-course', { data: obj })
            .then(res => {
                this.getCoursesForSemester();
                toast('Brisanje predmeta sa semestra je uspješno izvršeno.');
            })
            .catch(err => {
                toast('Došlo je greške! Brisanje predmeta sa semestra nije uspjelo.');
            });
    }

    changeSemester() {
        if (!this.state.studyProgramSemesterId) {
            this.setState({ semErr: true });
            toast('Morate unijeti broj semestra.');
            return;
        }

        const { course } = this.state;
        this.setState({ semErr: false });

        let obj = {
            id: course.id
        };

        axios.put(`study-programs/course/remove-semester/${this.props.semesterId}`, { ...obj })
            .then(res => {
                axios.post(`study-programs/course/add-semester/${this.state.studyProgramSemesterId}`, { ...obj })
                    .then(re => {
                        toast('Promjena semestra je uspješno izvršena.');
                        this.setState({ showChangeSemesterMode: false });
                        this.getCoursesForSemester();
                    });
            })
            .catch(err => {
                toast('Došlo je do greške! Promjena semestra nije uspješno izvršena.');
            });
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                {this.state.showEditMode &&
                <EditCourse
                    closeEditMode={() => this.setState({ showEditMode: false })}
                    course={this.state.course}
                    getCoursesForSemester={this.getCoursesForSemester}
                />}
                {this.state.showChangeSemesterMode && <div>
                    <h3>Promjena semestra za predmet: {this.state.course.courseBasic.name}</h3>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field
                                error={this.state.semErr}
                                control={Select}
                                clearable
                                options={this.state.semesters}
                                label="Broj semestra"
                                value={this.state.studyProgramSemesterId}
                                onChange={this.handleInputChange}
                                name="studyProgramSemesterId"
                                placeholder="Odaberite broj semestra"
                            />
                            <Form.Field />
                        </Form.Group>
                        <Button
                            color="blue"
                            onClick={this.changeSemester}
                        >  Sačuvaj promjenu semestra
                        </Button>
                        <Button
                            color="blue"
                            size="small"
                            basic="true"
                            onClick={() => this.setState({ showChangeSemesterMode: false })}
                        >  Odustani
                        </Button>
                    </Form>
                    <br />
                </div>
                }
                {this.state.data.length ?
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width="1">R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2"> Naziv predmeta</Table.HeaderCell>
                                <Table.HeaderCell width="1"> ECTS</Table.HeaderCell>
                                <Table.HeaderCell width="2"> Šifra</Table.HeaderCell>
                                <Table.HeaderCell width="2"> P + V + S + T</Table.HeaderCell>
                                <Table.HeaderCell width="2"> Tip predmeta</Table.HeaderCell>
                                {!this.props.studentService && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Table.HeaderCell />}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.state.data.map((el, index) =>
                            (<Table.Row key={el.id}>
                                <Table.Cell verticalAlign="middle" width={1}>
                                    {index + 1}.
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan="2">
                                    <Grid columns={1} centered className="stackable">
                                        <Grid.Row verticalAlign="middle">
                                            <Grid.Column width="10">
                                                {el.courseBasic.name}
                                            </Grid.Column>
                                            <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                <span style={{ color: '#a6a4a1' }}>
                                                    {el.courseBasic.comment && <Label as="a" basic><Icon name="comment alternate outline" />{el.courseBasic.comment}</Label>}
                                                    {el.fromOtherStudyProgram && <Label as="a" basic><Icon name="share" />drugi SP/NPP</Label>}
                                                    {el.prerequisiteCourse && <Label as="a" basic><Icon name="warning" />uslovni predmet</Label>}
                                                </span>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    {/* {el.courseBasic.name} */}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.ects}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width="2">
                                    {el.code}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width="2">
                                    {el.lectureNumber ? el.lectureNumber : '0'} + {el.exerciseNumber ? el.exerciseNumber : '0'} + {el.seminarNumber ? el.seminarNumber : '0'} + {el.tutorialNumber ? el.tutorialNumber : '0'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width="2">
                                    {el.mandatory ? 'Obavezni' : 'Izborni'}
                                </Table.Cell>
                                {!this.props.studentService && (localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') &&  <Table.Cell verticalAlign="middle" textAlign="center">
                                    <Popup
                                        content="Izmjena / prikaz"
                                        position="top center"
                                        trigger={<Button color="green" circular icon="pencil alternative" basic="true" onClick={() => this.setState({ showEditMode: true, course: el })}></Button>}
                                    />
                                    <Popup
                                        content="Promjena semestra"
                                        position="top center"
                                        trigger={<Button color="blue" circular icon="copy outline" basic="true" onClick={() => this.setState({ showChangeSemesterMode: true, course: el })}></Button>}
                                    />
                                    <Popup
                                        content="Brisanje"
                                        position="top center"
                                        trigger={<Button color="red" circular icon="trash alternate" basic="true" onClick={() => this.deleteCourse(el.id)}></Button>}
                                    />
                                </Table.Cell>}
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                    : this.state.showFiltersOnButton ?
                        <NoFilterDataMessage />
                        : <NoDataMessage />
                }
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}

export default SemesterAddedCourses;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/SemesterAddedCourses.js